export default __webpack_public_path__ + "static/media/about_img2.673a5e0d.png";